import React from "react";
var __jsx = React.createElement;
var OilInfoList = function OilInfoList(_ref) {
  var _section$content;
  var section = _ref.section;
  if (!((_section$content = section.content) !== null && _section$content !== void 0 && _section$content.length)) return null;
  return /*#__PURE__*/React.createElement("section", {
    className: "px-4 pt-4 pb-7 md:px-6 md:pt-0  md:pb-16"
  }, section.title && /*#__PURE__*/React.createElement("h3", {
    className: "text-lg md:text-2xl font-bold text-[#1B2035] block max-w-[1200px] mx-auto  mb-4 md:mb-6"
  }, section.title), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-2 md:grid-cols-6 gap-2 md:gap-4 md:max-w-[1200px] md:mx-auto"
  }, section.content.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      key: item.id,
      className: "flex flex-col items-center justify-center gap-1 md:gap-2 text-center bg-white rounded-lg pt-1 pb-2 h-[68px] md:px-2 md:py-1 md:h-[94px]"
    }, item.icon && /*#__PURE__*/React.createElement("span", {
      className: "flex items-center justify-center w-10 h-10"
    }, /*#__PURE__*/React.createElement("span", {
      className: "flex items-center justify-center w-[24px] h-[24px] md:w-[37px] md:h-[37px] rounded-full bg-[#FFECF3]"
    }, /*#__PURE__*/React.createElement("img", {
      loading: "lazy",
      src: item.icon,
      alt: item.title,
      className: "object-contain w-6 h-6 md:w-8 md:h-8"
    }))), /*#__PURE__*/React.createElement("span", {
      className: "text-sm font-medium text-[#020202] leading-5"
    }, item.title));
  })));
};
export default OilInfoList;